var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 5.00001V4.33334C13.8333 3.39992 13.8333 2.93321 13.6517 2.57669C13.4919 2.26308 13.2369 2.00812 12.9233 1.84833C12.5668 1.66667 12.1001 1.66667 11.1667 1.66667H9.83333C8.89991 1.66667 8.4332 1.66667 8.07668 1.84833C7.76308 2.00812 7.50811 2.26308 7.34832 2.57669C7.16667 2.93321 7.16667 3.39992 7.16667 4.33334V5.00001M8.83333 9.58334V13.75M12.1667 9.58334V13.75M3 5.00001H18M16.3333 5.00001V14.3333C16.3333 15.7335 16.3333 16.4335 16.0608 16.9683C15.8212 17.4387 15.4387 17.8212 14.9683 18.0609C14.4335 18.3333 13.7335 18.3333 12.3333 18.3333H8.66667C7.26654 18.3333 6.56647 18.3333 6.03169 18.0609C5.56129 17.8212 5.17883 17.4387 4.93915 16.9683C4.66667 16.4335 4.66667 15.7335 4.66667 14.3333V5.00001",
    stroke: "#6E6E78",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.4c4d6b9a.svg";
export { ForwardRef as ReactComponent };